<template>
  <!--处理告警事件窗口-->
  <el-dialog
    class="handle-alarm-event-modal"
    title="告警事件处理"
    :visible="modalOpen"
    :append-to-body="true"
    width="600px"
    :before-close="handleModalCancel"
  >
    <div style="padding-top:5px">
      <ul class="label-value-list">
        <li><span class="label">区域</span><span class="value">{{ getNameById(alarmEvent.regionId, $globalData.regions) }}</span></li>
        <li><span class="label">名称</span><span class="value">{{ alarmEvent.resourceName }}</span></li>
        <li><span class="label">告警状态</span><span class="alarm-value" :class="colorClassFromResourceAlarmState(alarmEvent.resourceKind, alarmEvent.alarmState, alarmEvent.eventType, 1, 0, 0)">
              {{ alarmEvent.alarmStateText }}</span>
        </li>
        <li><span class="label">告警级别</span><span class="value">{{ getNameById(alarmEvent.alarmLevel, $type.alarmLevels) }}</span></li>
        <li><span class="label">数值</span><span class="value">{{ alarmEvent.workStateText }}</span></li>
        <li><span class="label">事件类型</span><span class="value">{{ alarmEvent.eventTypeText }}</span></li>
        <li><span class="label">事件子类型</span><span class="value">{{ alarmEvent.eventSubTypeText }}</span></li>
        <li><span class="label">事件触发时间</span><span class="value">{{ strDateTimeFromSTime_t(alarmEvent.happenTime) }}</span></li>
        <li><span class="label">正常区间</span><span class="value">{{ alarmEvent.alarmRuleText }}</span></li>
        <li><span class="label">处理意见：</span></li>
      </ul>
    </div>
    <textarea ref="handleIdeaTextArea" warp="virtual" class="textAreaContent" :value="alarmEvent.handleIdea"></textarea>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handlePrintTrue" :disabled="alarmEvent.handled">真实告警</el-button>
      <el-button @click="handlePrintFalse" :disabled="alarmEvent.handled">误报</el-button>
      <el-button @click="handleClearHandleIdea" :disabled="alarmEvent.handled">清空</el-button>
      <el-button @click="handleModalSubmit" :disabled="alarmEvent.handled">提交</el-button>
      <el-button @click="handleModalCancel">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import HandleAlarmEventModal from './HandleAlarmEventModal.js'
export default HandleAlarmEventModal
</script>

<style lang="scss">
  @import "HandleAlarmEventModal";
</style>



// WEBPACK FOOTER //
// src/views/common/handleAlarmEventModal/HandleAlarmEventModal.vue